import Glide from '@glidejs/glide'

export default class TopicSlider {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.topic-slider .glide'), el => {
            new TopicSlider(el)
        });
    }

    constructor(el) {
        if (!el) return;
        this.el = el;

        new Glide(this.el, {
                gap: 16,
				swipeThreshold: window.innerWidth > 1024 ? 80 : 20,
                peek: {
                    before: window.innerWidth > 1024 ? (window.innerWidth - el.getBoundingClientRect().width) / 2 : 0,
                    after: window.innerWidth > 1024 ? (window.innerWidth - el.getBoundingClientRect().width) / 2 : window.innerWidth / 10
                },
            }
        ).mount();
    }
}
